import { render, staticRenderFns } from "./RdIcon.vue?vue&type=template&id=3331a65b&"
import script from "./RdIcon.vue?vue&type=script&lang=ts&"
export * from "./RdIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports